import React, { useEffect } from 'react';

import { Navbar } from './components';
import { About, Footer, Header, Skills, Testimonials, Work } from './container';
import './App.scss';

import AOS from 'aos';
import 'aos/dist/aos.css';

const App = () => {
  useEffect(() => {
    AOS.init({startEvent: 'load'});
    AOS.refreshHard();
  }, [])

  return (
        <div className='app'>
            <Navbar />
            <Header />
            <About />
            <Work />
            <Skills />
            {/* <Testimonials /> */}
            <Footer />
        </div>                    
  );
}

export default App;  